import { computed } from 'vue';

import { useEstimatedSegments } from './useEstimatedSegments';
import { useVisibleCalculationItems } from './useVisibleCalculationItems';

/**
 * @deprecated Use useEstimatedSegments with appropriate filters instead
 * This composable is kept for backward compatibility
 */
export function useCurrentEstimatedSegments() {
  const { hiddenFilter } = useVisibleCalculationItems();

  const reactiveFilters = computed(() => ({
    visibility: 'visible-only' as const,
    hidden: hiddenFilter.value,
    ruleTypes: ['calculation'],
    includeChildRules: false,
    includeSegmentRules: true,
    includeGroupRules: true,
  }));

  return useEstimatedSegments(reactiveFilters);
}
